import {Serializers} from "../../interfaces/serializer";
import {DataSourceMetric} from '../../interfaces/metrics';
import {MetricComponentObjects} from '../../classes/metric-component-object';

export const DATA_SOURCES_METRICS_STATE_NAME = 'dataSourcesMetrics';

export interface DataSourcesMetricsState {
  serialized: Serializers<DataSourceMetric>;
  componentObject: MetricComponentObjects;
  loading: boolean;
  loaded: boolean;
}
